<template>
  <div>
    <el-dialog
      title="修改密码"
      center
      :visible="true"
      @before-close="onClose"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="mustUpdate == null ? true : !mustUpdate"
      width="400px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="100px"
        size="mini"
      >
        <el-form-item label="新密码" prop="password">
          <el-input
            v-model="form.password"
            password="true"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            password="true"
            v-model="form.confirmPassword"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="margin-left: 20px; margin-top: 30px">
        密码规则：
        <li style="font-size: x-small">密码不能少于6位、多于16位</li>
        <li style="font-size: x-small">密码中不能含有空格</li>
        <li style="font-size: x-small">密码中不能包含用户名或者用户名拼音</li>
        <li style="font-size: x-small">纯数字密码不能含有连续3位的相同数字</li>
        <li style="font-size: x-small">纯数字密码不能含有连续3位的递增数字</li>
        <li style="font-size: x-small">纯数字密码不能含有连续3位的递减数字</li>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="onClose"
          :disabled="mustUpdate == null ? false : mustUpdate"
          >取消</el-button
        >
        <el-button type="primary" @click="submit()" style="margin-left: 30px"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "ChangePasswordDialog";

export default {
  data() {
    return {
      form: {
        confirmPassword: "",
        password: "",
        mustUpdate: null,
      },
      rules: {
        password: [
          { required: true, message: " ", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        confirmPassword: [{ required: true, message: " ", trigger: "blur" }],
      },
    };
  },
  components: {},

  created() {
    let paramsFromOutside = dialogutil.getData(DialogName);

    if (!paramsFromOutside) {
      return;
    }

    this.mustUpdate = paramsFromOutside.mustUpdate;
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      this.update();
    },

    /**
     * 修改密码
     */
    async update() {
      try {
        if (
          this.form.password.length == null ||
          this.form.password.length < 6
        ) {
          this.$message({
            message: "密码不能少于6位",
            type: "fail",
          });
          return;
        }

        if (this.form.password != this.form.confirmPassword) {
          this.$message({
            message: "两次输入的密码不一致",
            type: "fail",
          });
          return;
        }

        // 弹确认框
        await this.$confirm(`确认修改密码？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updateAdministratorPassword`,
            {
              password: this.form.password,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose(null);
      } catch (e) {}
    },

    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>